<template>
  <USkeleton
    v-if="isLoading"
    class="h-[40px] mt-[16px]"
    :ui="{
      base: 'animate-pulse round-lg bg-[#DEDEDE]',
    }"
    data-testid="button-load-more-content-skeleton"
  />
  <button
    v-else
    class="rounded-[8px] bg-[#ffffff] hover:bg-[#fbd9d9] border-[#f7f7f7] hover:border-[#fbd9d9] active:bg-[#fbd9d9] active:border-[#fbd9d9] border-[2px] border-solid mt-[16px] py-[12px] px-[8px] flex items-center justify-center gap-[8px] group"
    data-testid="button-load-more-content"
    ontouchstart
  >
    <span
      class="font-[500] text-[14px] leading-[20px] text-[#292828] text-center"
    >
      ดูเพิ่มเติม
    </span>
    <div
      class="border-[1px] group-hover:border-[0px] group-active:border-[0px] border-[#E0E0E0] bg-[#FFFFFF] h-[24px] w-[24px] rounded-[6px] flex justify-center items-center"
    >
      <Icon name="i-tabler:chevron-down" class="h-[18px] w-[18px]" mode="svg" />
    </div>
  </button>
</template>
<script setup lang="ts">
defineProps({
  isLoading: {
    type: Boolean,
    default: true,
  },
});
</script>
